import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { PageTitle, Table, Td } from "../../components/admin/AdminUi";
import { api, errMsg } from "../../lib/api";
import { ago } from "../../lib/dnsProviders";
import DomainEarningsCard from "../../components/admin/domains/DomainEarningsCard";

const STATUS = {
  live: "text-emerald-700 border-emerald-200 bg-emerald-50",
  verified: "text-amber-700 border-amber-200 bg-amber-50",
  failed: "text-rose-700 border-rose-200 bg-rose-50",
  pending: "text-slate-600 border-slate-200 bg-slate-50",
  offline: "text-slate-600 border-slate-300 bg-slate-100",
};
const LABEL = { live: "Live", verified: "DNS ready · needs credits", failed: "Problem", pending: "Waiting for DNS", offline: "Offline (by admin)" };
const month = (p) => (p ? new Date(`${p}-01T00:00:00Z`).toLocaleDateString("en-IN", { month: "short", year: "numeric" }) : null);

const Status = ({ r }) => (
  <div>
    <span className={`text-[10px] font-mono px-1.5 py-0.5 rounded border ${STATUS[r.status] || STATUS.pending}`} data-testid={`admin-domain-status-${r.id}`}>
      {r.legacy ? "Old setup" : r.custom_domain.billing_paused && !r.custom_domain.live ? "Paused · unpaid" : LABEL[r.status] || r.status}
    </span>
    {r.custom_domain.paid_period && <p className="mt-1 text-[11px] text-slate-500" data-testid={`admin-domain-paid-${r.id}`}>{r.custom_domain.live ? "Paid for" : "Last paid:"} {month(r.custom_domain.paid_period)}</p>}
    {r.custom_domain.monitor_message && r.status !== "offline" && <p className="mt-1 text-[11px] text-slate-500 max-w-xs">{r.custom_domain.monitor_message}</p>}
  </div>
);

export default function AdminDomains() {
  const [rows, setRows] = useState([]);
  const [tick, setTick] = useState(0);
  const load = () => api.adminDomains().then(setRows).catch(() => {});
  useEffect(() => { load(); }, []);
  const toggle = async (r) => {
    try { await api.adminDomainLive(r.id, !r.custom_domain.live); toast.success(r.custom_domain.live ? "Domain taken offline" : "Domain is live again — any fee due was taken from the owner's credits"); load(); setTick((t) => t + 1); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="admin-domains">
      <PageTitle title="Custom domains" desc="Customers add one DNS record and their domain goes live by itself with free SSL (powered by Domainee). The setup fee is taken at go-live; the monthly fee at go-live and on the 1st of every month — unpaid domains pause until the owner tops up." />
      <DomainEarningsCard refreshKey={tick} />
      <Table head={["Domain", "Project", "Status", "Last check", ""]} testid="admin-domains-table" empty={rows.length === 0 && "No custom domains yet."}>
        {rows.map((r) => (
          <tr key={r.id} data-testid={`admin-domain-row-${r.id}`} className="hover:bg-slate-50">
            <Td><div className="font-mono text-slate-900">{r.custom_domain.root_domain || r.custom_domain.domain}</div>{r.paid && <div className="text-xs text-emerald-600">fee paid</div>}
              {r.custom_domain.redirect && <div className="text-[11px] text-slate-500" data-testid={`admin-domain-apex-${r.id}`}>+ {r.custom_domain.redirect.domain}: {r.custom_domain.redirect.error ? "not available" : r.custom_domain.redirect.verified ? "forwarding" : "waiting for DNS"}</div>}</Td>
            <Td><div className="text-slate-700">{r.name}</div><div className="text-xs text-slate-500">{r.owner_email}{!r.published && " · not published"}</div></Td>
            <Td><Status r={r} /></Td>
            <Td className="text-xs text-slate-500 whitespace-nowrap">{ago(r.custom_domain.checked_at)}</Td>
            <Td>
              {(r.custom_domain.live || r.custom_domain.verified) && (
                <button onClick={() => toggle(r)} data-testid={`admin-domain-live-${r.id}`}
                  className="h-8 px-3 rounded-lg border border-slate-300 text-xs text-slate-700 hover:bg-slate-100 whitespace-nowrap">{r.custom_domain.live ? "Take offline" : "Bring live"}</button>
              )}
            </Td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
